// extracted by mini-css-extract-plugin
export var cardTitle = "_i9-1";
export var commentBubble = "_i9-e";
export var commentForm = "_i9-a";
export var commentInput = "_i9-b";
export var commentLabel = "_i9-d";
export var commentPrompt = "_i9-9";
export var csatCard = "_i9-0";
export var feedbackSection = "_i9-7";
export var starDisabled = "_i9-6";
export var starEmpty = "_i9-5";
export var starFilled = "_i9-4";
export var starWrapper = "_i9-3";
export var starsContainer = "_i9-2";
export var submittedComment = "_i9-c";
export var thankYouText = "_i9-8";